/*

    Module: jv.common.chart.directive
    Directive: jv-chart

    Usage:
        <div jv-chart chart-type="multi-line" chart-data="data" chart-series="series" chart-labels="labels"></div>
    Available Chart Types(chart-type)(String):
        1) column
        2) stackedColumn
        3) groupedColumn
        4) bar
        5) stackedBar
        6) groupedBar
        7) pie
        8) line
        9) lines
        10) doughnut
    Chart-Series(Array):
        Applicable for *line, *bar, *bar-column only.
        Depending on chart-series - bar, bar-column, line will display as grouped chart type.
        series = ['SeriesA', 'SeriesB'] will display 2 groups or lines.
    Chart-Data(Array):
        Based on chart-series, data should reflect the data. If series has 2 options, then data needs to be an array of 2 series and each array should
        have the value of the data points.
        data = [[19,20,21,22],[12,12,1,0]] #Example: For grouped bar and 4 data points for each group.
    Chart-Labels(Array):
        x axis labels(line, *bar, *bar-column) or series label (pie)
 */

angular.module('jv.common.chart.directive', ['chart.js'])
.directive('jvChart', ['$compile',
    function($compile) {
        var template;
        var options = {
            responsive: true,
            animationEasing: 'easeOutCirc',
            animationSteps: 20,
            legend: {
                display: false,
                position: 'bottom',
                onHover: function(e) {
                   e.target.style.cursor = 'pointer';
                },
                labels: {
                    usePointStyle: true
                }
            },
            elements: {
                line: {
                    fill: false,
                    borderColor: '#61C5C2'
                }
            },
            fontSize: 10,
            hover: {
               onHover: function(e) {
                  var point = this.getElementAtEvent(e);
                  if (point.length) {
                    e.target.style.cursor = 'pointer';
                  } else {
                    e.target.style.cursor = 'default';
                  }
               }
            }
        };

        var colors = [ '#8BE4E1','#b8d3ed','#cdc2e8','#f679b0','#f9b683','#fcf588','#a1e2ab','#55ABA8','#3d87cf','#7354bd','#f01978', '#f57d21','#f9ed25','#38B24A','#438A88','#215485','#5b3ea0','#c90d60','#e86b0a','#e2d606','#2c8b3a'];

        var colorBar = [];
        var colorColumn = [];
        var colorDatasetOverride = [];

        for (var i = 0; i < 21; i++) {
            var colorObject = {
                backgroundColor: colors[i]
            };
            colorDatasetOverride.push(colorObject);
        }

        var getColorDataSetOveride = function(count) {
            for (var i = 0; i < count; i++) {
                var colorObject = {
                    backgroundColor: colors[i]
                };
                colorDatasetOverride.push(colorObject);
            }
            return colorDatasetOverride;
        };

        var getBarColors = function(count) {
            for (var i = 0; i < count; i++) {
                colorBar.push('#F3A79E');
            }
            return colorBar;
        };

        var getColumnColors = function(count) {
            for (var i = 0; i < count; i++) {
                colorColumn.push('#61C5C2');
            }
            return colorColumn;
        };

        var getTemplate = function(chartType) {
            switch(chartType){
                case 'bar':
                    template = '<div class="jv-chart"><canvas chart-horizontal-bar chart-series="jvchartseries" chart-data="jvchartdata" chart-labels="jvchartlabels" chart-options="options" chart-colors="barColors" chart-click="handleClick" height="250"></canvas></div>';
                    break;
                case 'stackedBar':
                case 'groupedBar':
                    template = '<div class="jv-chart"><canvas chart-horizontal-bar chart-series="jvchartseries" chart-data="jvchartdata" chart-labels="jvchartlabels" chart-options="options" chart-colors="colors" chart-dataset-override="colorDatasetOverride" chart-click="handleClick" height="250"></canvas></div>';
                    break;
                case 'column':
                    template = '<div class="jv-chart chart chart-bar"><canvas chart-bar chart-series="jvchartseries" chart-data="jvchartdata" chart-labels="jvchartlabels" chart-options="options" chart-colors="columnColors" chart-click="handleClick" height="300"></canvas></div>';
                    break;
                case 'stackedColumn':
                case 'groupedColumn':
                    template = '<div class="jv-chart chart chart-bar"><canvas chart-bar chart-series="jvchartseries" chart-data="jvchartdata" chart-labels="jvchartlabels" chart-options="options" chart-colors="colors" chart-dataset-override="colorDatasetOverride" chart-click="handleClick" height="300"></canvas></div>';
                    break;
                case 'line':
                case 'lines':
                    template = '<div class="jv-chart"><canvas chart-line chart-series="jvchartseries" chart-data="jvchartdata" chart-labels="jvchartlabels" chart-options="options" chart-colors="colors" chart-dataset-override="colorDatasetOverride" chart-click="handleClick"></canvas></div>';
                    break;
                case 'pie':
                    template = '<div class="jv-chart"><canvas chart-pie chart-series="jvchartseries" chart-data="jvchartdata" chart-labels="jvchartlabels" chart-options="options" chart-colors="colors" chart-click="handleClick"></canvas></div>';
                    break;
                case 'doughnut':
                    template = '<div class="jv-chart"><canvas chart-doughnut chart-series="jvchartseries" chart-data="jvchartdata" chart-labels="jvchartlabels" chart-options="options" chart-colors="colors" chart-click="handleClick"></canvas></div>';
                    break;
                default:
                    break;
            }

            return template;
        };

        var setSpecificOptions = function(options, showLegend, stacked, showTicksAndGrids, ignoreLabelNumberCheckX, ignoreLabelNumberCheckY) {
            options.legend.display = showLegend;
            options.scales = {
                yAxes: [{
                    stacked: stacked,
                    gridLines: {
                        display: showTicksAndGrids,
                        drawBorder: showTicksAndGrids
                    },
                    ticks: {
                        beginAtZero: true,
                        fontSize: 10,
                        autoSkip: false,
                        display: showTicksAndGrids,
                        userCallback: function(label) {
                            // when the floored value is the same as the value we have a whole number
                            if (!ignoreLabelNumberCheckY) {
                                if (Math.floor(label) === label) {
                                    return label;
                                }
                            } else {
                                return label;
                            }
                        }
                    }
                }],
                xAxes: [{
                    stacked: stacked,
                    gridLines: {
                        display: showTicksAndGrids,
                        drawBorder: showTicksAndGrids
                    },
                    ticks: {
                        beginAtZero: true,
                        fontSize: 10,
                        autoSkip: false,
                        display: showTicksAndGrids,
                        userCallback: function(label) {
                            // when the floored value is the same as the value we have a whole number
                            if (!ignoreLabelNumberCheckX) {
                                if (Math.floor(label) === label) {
                                    return label;
                                }
                            } else {
                                return label;
                            }
                        }
                    }
                }]
            };
        };

        var setSpecificOptionsPerChartType = function(options, chartType) {
            switch(chartType) {
                case 'bar':
                    setSpecificOptions(options, false, false, true, false, true);
                    break;
                case 'column':
                    setSpecificOptions(options, false, false, true, true, false);
                    break;
                case 'line':
                    setSpecificOptions(options, false, false, true, true, false);
                    break;
                case 'stackedBar':
                    setSpecificOptions(options, true, true, true, false, true);
                    break;
                case 'stackedColumn':
                    setSpecificOptions(options, true, true, true, true, false);
                    break;
                case 'pie':
                    setSpecificOptions(options, true, false, false, true, true);
                    break;
                case 'doughnut':
                    setSpecificOptions(options, false, false, false, true, true);
                    break;
                case 'lines':
                    setSpecificOptions(options, true, false, true, true, false);
                    break;
                case 'groupedBar':
                    setSpecificOptions(options, true, false, true, false, true);
                    break;
                case 'groupedColumn':
                    setSpecificOptions(options, true, false, true, true, false);
                    break;
                default:
                    break;
            }
        };


        return {
            scope: {
                jvchartdata: '=jvChartData',
                jvchartlabels: '=jvChartLabels',
                jvchartseries: '=jvChartSeries',
                jvcharttype: '=jvChartType',
                jvchartclick: '=jvChartClick',
                jvcansearch: '=jvCanSearch'
            },
            link: function(scope, element) {
                scope.options = angular.copy(options);
                scope.colors = angular.copy(colors);
                scope.barColors = getBarColors(scope.jvchartdata.length);
                scope.columnColors = getColumnColors(scope.jvchartdata.length);
                scope.colorDatasetOverride = getColorDataSetOveride(scope.jvchartdata.length);
                setSpecificOptionsPerChartType(scope.options, scope.jvcharttype);

                if (!scope.jvcansearch && scope.options && scope.options.hover) {
                    scope.options.hover.onHover = function(e) {
                            e.target.style.cursor = 'default';
                    };
                }

                scope.handleClick = function(points, event) {
                    // Get current chart
                    // Added the condition to check if the user has clicked the chart legends and if he has clicked during widget addition
                    // If yes do not perform search redirect operation
                    if(points.length > 0 && angular.isDefined(scope.jvchartseries) && angular.isDefined(scope.jvchartclick)) {
                        var chart = points[0]._chart.controller;
                        var activePoint = chart.getElementAtEvent(event);
                        if (activePoint.length > 0) {
                            // Get current Dataset
                            var level2Index = activePoint[0]._datasetIndex;
                            // Get current serie by dataset index
                            var series = scope.jvchartseries[level2Index];
                            //get the internal index of slice in pie chart
                            var level1Index = activePoint[0]['_index'];
                            scope.jvchartclick(level1Index, level2Index, series);
                        }
                    }
                };

                scope.$on('create', function(event, c) {
                    chart = c;
                });

                scope.$watch('jvcharttype', function(newVal) {
                    if (newVal) {
                        setSpecificOptionsPerChartType(scope.options, newVal);
                        var template = getTemplate(newVal);
                        element.html(template);
                        $compile(element.contents())(scope);
                    }
                });

                var template = getTemplate(scope.jvcharttype);
                element.html(template);
                $compile(element.contents())(scope);
            }
        };
    }
]);
